import { GridListItemProps } from "react-aria-components";
import { ReactNode } from "react";

export interface MDSGridListItemProps extends Omit<GridListItemProps, "children"> {
  children?: ReactNode;
  leftAddon?: ReactNode;
  rightAddon?: ReactNode;
}

export enum MDSGridListItemSlotName {
  LeftAddon = "leftAddon",
  RightAddon = "rightAddon",
}
